import React, { FunctionComponent } from 'react';
import styles from './ActionLinks.scss';
import { useTranslation } from 'react-i18next';
import IsPageOwner from '../../IsPageOwner/IsPageOwner';

export const ActionLinks: FunctionComponent = () => {
  const { t } = useTranslation('common', { useSuspense: false });
  return (
    <div className={styles.container}>
      <IsPageOwner>
        <button className="jg-text--link">
          {t('activity.totals.actions.addProgress')}
        </button>
      </IsPageOwner>
      <button className="jg-text--link">{t('common.share')}</button>
    </div>
  );
};
